export default __webpack_public_path__ + "static/media/fabric-baubles.b8e11af1.png";